import { temAcesso } from '@/shared/auth/temAcesso'

const Convenios = () => import('./ConvenioLista.vue')
const Detalhes = () => import('./ConvenioDetalhes.vue')

export default {
    path: 'gescon/financeiro/convenios',
    name: 'Gescon_Convenios_Financeiro',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-FINAN-CONV-00')) {
            next()
        }
    },
    children: [
        {
            path: '/gescon/financeiro/convenios',
            name: 'Gescon_Convenios_Financeiro',
            component: Convenios,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FINAN-CONV-00')) {
                    next()
                }
            }
        },
        {
            path: '/gescon/financeiro/convenios/detalhes/:idConvenio',
            name: 'Gescon_Convenios_Financeiro_Detalhar',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FINAN-CONV-00')) {
                    next()
                }
            }
        }
    ]
}
